import wrapHOC from 'utils/framework/wrapHOC';
import wrapHOCComponent from 'utils/framework/wrapHOCComponent';
import Application from 'utils/framework/Application';
import wrapUFE from 'utils/framework/wrapUFE';
import wrapUFEFunctional from 'utils/framework/wrapUFEFunctional';

export default {
    Application,
    wrapComponent: (component, name, hasCtrlr) => {
        component.class = name;
        const modifiedComponent = wrapUFE(component, hasCtrlr);

        return modifiedComponent;
    },
    wrapFunctionalComponent: wrapUFEFunctional,
    wrapHOC,
    wrapHOCComponent
};
